import { useEffect } from "react";
import { useDataLayer } from "~/hooks/useDataLayer";
import PrismicPage from "~/views/PrismicPage";

function Page(props) {
  const { push } = useDataLayer();

  useEffect(() => {
    const onClick = (event: MouseEvent) => {
      const target = event.target;
      if (!(target instanceof Element)) return;
      const link = target.closest("a");
      if (!link?.href.includes("aiaiai-software.s3")) return;

      // GTM sends "Software Downloaded". Identity comes from the signed-in identify.
      push({
        event: "software_download",
        software: "EQ Machine",
        download_url: link.href,
      });
    };

    document.addEventListener("click", onClick);
    return () => document.removeEventListener("click", onClick);
  }, [push]);

  return <PrismicPage {...props} />;
}

Page.getInitialProps = async (ctx) => {
  try {
    ctx.query.pageUID = "eq-machine";

    const viewProps = await PrismicPage.getInitialProps(ctx);

    // return the props for the Page component
    return {
      ...viewProps,
    };
  } catch (err) {
    console.error(err);
    return {};
  }
};

export default Page;
